export function estimateLabel(ticketNumber: string | null | undefined, version: number): string {
  return ticketNumber && /^\d+$/.test(ticketNumber)
    ? `СМ-${ticketNumber}-V${version}`
    : `Смета · версия ${version}`;
}
